import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import './app/shared/components/charts/chart.config';

platformBrowser()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => console.error(err));
